import React from 'react'
import HipercardImg from '../../../assets/icons/hipercard-icon.png'
import HipercardImgPb from '../../../assets/icons/hipercard-icon-pb.png'
import { StyledIcon } from './styled-icon.style'

/**
 * @param {boolean} disabled
 * if true, set the img to black and white
 */
const HipercardIcon = ({ disabled, className }) => (
	<StyledIcon className={className}>
		<img src={disabled ? HipercardImgPb : HipercardImg} alt="Ícone Hipercard" />
	</StyledIcon>
)

export default HipercardIcon
